import React, { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { DatumVeld, geldigeDatum, minDatum, teVroeg, TE_VROEG } from "@/components/DatumVeld";
import { api } from "@/lib/api";
import { toast } from "sonner";

const MAX = 500;

// v13 B2: de bedrijfsleider voegt zelf een punt met deadline toe (of past zijn eigen open punt aan).
export function MijnPuntDialog({ open, onOpenChange, punt, onSaved }) {
  const [wat, setWat] = useState("");
  const [deadline, setDeadline] = useState("");
  const [fout, setFout] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    if (!open) return;
    setWat(punt?.wat || "");
    setDeadline(punt?.deadline || "");
    setFout("");
  }, [open, punt]);
  const opslaan = async () => {
    if (!wat.trim()) { setFout("Schrijf eerst wat je gaat doen."); return; }
    if (!geldigeDatum(deadline)) { setFout("Kies een geldige deadline."); return; }
    if (teVroeg(deadline, punt?.deadline)) { setFout(TE_VROEG); return; }
    setBusy(true);
    try {
      if (punt) await api.patch(`/mijn-punten/${punt.id}`, { wat, deadline });
      else await api.post("/mijn-punten", { wat, deadline });
      toast.success(punt ? "Punt aangepast" : "Punt toegevoegd");
      onOpenChange(false);
      onSaved();
    } catch (e) {
      setFout(e?.response?.data?.detail || "Opslaan mislukt. Probeer het opnieuw.");
    } finally {
      setBusy(false);
    }
  };
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="mijn-punt-dialog" className="max-w-md" onInteractOutside={(e) => { if (wat.trim()) e.preventDefault(); }}>
        <DialogHeader>
          <DialogTitle className="font-heading">{punt ? "Punt bewerken" : "Punt toevoegen"}</DialogTitle>
          <DialogDescription>Je OM ziet het punt en bespreekt het met je in de call.</DialogDescription>
        </DialogHeader>
        <div className="space-y-3">
          <div>
            <label htmlFor="mijn-punt-wat" className="block text-xs font-medium text-zinc-500 mb-1">Wat ga je doen?</label>
            <textarea id="mijn-punt-wat" data-testid="mijn-punt-wat" rows={3} maxLength={MAX} value={wat} onChange={(e) => { setWat(e.target.value); setFout(""); }}
              className="w-full px-3 py-2 rounded-md border border-zinc-300 focus:outline-none focus:ring-2 focus:ring-blue-600 text-sm text-zinc-900" />
            <div className="text-[10px] text-zinc-400 text-right" data-testid="mijn-punt-teller">{wat.length}/{MAX}</div>
          </div>
          <div>
            <label className="block text-xs font-medium text-zinc-500 mb-1">Deadline</label>
            <DatumVeld testid="mijn-punt-deadline" aria-label="Deadline" value={deadline} onChange={(v) => { setDeadline(v); setFout(""); }} min={minDatum(punt?.deadline)} />
          </div>
          {fout && <p data-testid="mijn-punt-fout" role="alert" className="text-sm text-rose-700">{fout}</p>}
        </div>
        <DialogFooter className="gap-2">
          <button type="button" data-testid="mijn-punt-annuleren" onClick={() => onOpenChange(false)}
            className="min-h-[44px] px-4 rounded-md border border-zinc-300 text-sm font-semibold text-zinc-700 hover:border-zinc-500 transition-colors">Annuleren</button>
          <button type="button" data-testid="mijn-punt-opslaan" onClick={opslaan} disabled={busy}
            className="min-h-[44px] px-4 rounded-md bg-zinc-950 text-white text-sm font-semibold uppercase tracking-wider hover:bg-zinc-800 disabled:opacity-60 transition-colors">
            {busy ? "Bezig…" : punt ? "Opslaan" : "Toevoegen"}
          </button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
